// extracted by mini-css-extract-plugin
export default {"labelColorIndicator":"ListLabelFilter-module__labelColorIndicator--Kp5TE","labelFilterButton":"ListLabelFilter-module__labelFilterButton--_hamy"};